var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-controller',_vm._b({attrs:{"receiveSchema":_vm.hasSchemaResource && _vm.schemaProps
      ? _vm.schemaProps.receive
      : null,"schema":_vm.hasSchemaResource
    && _vm.schemaProps
    && _vm.schemaProps.result
    && _vm.schemaProps.result.items,"has-schema-resource":_vm.hasSchemaResource,"receive":_vm.allProps.receive,"receiveAvailable":_vm.availableProps.receive,"all":_vm.allProps.result && _vm.allProps.result.items,"available":_vm.availableProps.result
    && _vm.availableProps.result.items,"loading":_vm.hasSchemaResource
      ? (
        !!_vm.schemaProps
        && _vm.schemaProps.loading
        && !(_vm.schemaProps.result && _vm.schemaProps.result.items)
      )
      : (
        _vm.allProps.loading
        && !(_vm.allProps.result && _vm.allProps.result.items)
      ),"details-loading":_vm.allProps.loading,"details-loaded":!!(_vm.allProps.result && _vm.allProps.result.items),"available-loading":_vm.availableProps.loading,"available-loaded":!!(
      _vm.availableProps.result
      && _vm.availableProps.result.items
    ),"value":_vm.value,"permanent":_vm.permanent},on:{"input":_vm.handleFilter}},'filter-controller',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }